import React from 'react';
import { Reveal } from './ui/Reveal';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Adriana M.',
  text: 'Lo que necesitaba, los bonos son de maravilla. Por fin entendí por qué siempre volvía a subir de peso. Los 24 pasos son súper claros y fáciles de seguir en el día a día.',
  age: '42 años'
}, {
  name: 'Carmen R.',
  text: 'Llevo 3 semanas y me siento con más energía que nunca. No paso hambre, disfruto las recetas y mis niveles de azúcar han mejorado muchísimo según mis últimos análisis.',
  age: '55 años'
}, {
  name: 'Lucía T.',
  text: 'Había probado de todo, desde pastillas hasta dietas líquidas. Este programa me enseñó a comer de verdad. La comunidad es un apoyo increíble cuando sientes que vas a flaquear.',
  age: '38 años'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-cream" data-id="element-106">
      <div className="max-w-6xl mx-auto px-6" data-id="element-107">
        <Reveal data-id="element-108">
          <div className="text-center mb-16" data-id="element-109">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-110">
              Mujeres reales, resultados reales
            </h2>
            <p className="text-gray-600" data-id="element-111">
              Únete a las cientos de mujeres que ya han transformado su vida.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-112">
          {testimonials.map((testimonial, index) => <Reveal key={index} delay={index * 0.1} data-id="element-113">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-sand relative h-full flex flex-col" data-id="element-114">
                <div className="flex gap-1 mb-4" data-id="element-115">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-coral text-brand-coral" data-id="element-116" />)}
                </div>
                <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-117">
                  "{testimonial.text}"
                </p>
                <div data-id="element-118">
                  <p className="font-bold text-brand-forest" data-id="element-119">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-120">{testimonial.age}</p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}